import {useContext} from 'react'
import Calendar from '../../../../components/Calendar/Calendar'
import CalendarEvent from './CalendarEvent'
import {handleDayCellDidMount} from '../../utils'
import {PaymentCalenderPageContext} from '../../contexts'

const PaymentCalenderContent = () => {
  const {calendarEvents, isLoadingCalendarEvents, calendarRef} = useContext(
    PaymentCalenderPageContext
  )
  return (
    <div className='position-relative'>
      <Calendar
        calendarRef={calendarRef}
        events={calendarEvents}
        isLoading={isLoadingCalendarEvents}
        eventContent={({event}) => <CalendarEvent event={event} />}
        dayCellDidMount={(info) => {
          handleDayCellDidMount(info, calendarEvents)
        }}
      />
    </div>
  )
}

export default PaymentCalenderContent
